<template>
  <div class="dialog-edu-info">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="460px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <el-form ref="FormRef" label-position="top" :rules="rules" label-width="80px" :model="formData">
        <el-form-item label="起止时间" prop="dateTime">
          <el-row>
            <el-col :span="9">
              <el-date-picker
                v-model="formData.start_time"
                type="month"
                placeholder="开始时间"
                format="yyyy-MM"
                value-format="yyyy-MM"
                :validate-event="false"
              />
            </el-col>
            <el-col :span="1" style="text-align: center;">
              <span>-</span>
            </el-col>
            <el-col :span="9">
              <el-date-picker
                v-if="!checked"
                v-model="formData.end_time"
                type="month"
                placeholder="结束时间"
                format="yyyy-MM"
                value-format="yyyy-MM"
                :validate-event="false"
              />
              <el-tag v-show="checked">至今</el-tag>
            </el-col>
            <el-col :span="5" style="text-align: center;">
              <el-checkbox v-model="checked">至今</el-checkbox>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="单位名称" prop="company">
          <el-input v-model="formData.company" placeholder="请输入单位名称" />
        </el-form-item>
        <!-- <el-form-item label="所属行业" prop="industry">
          <el-input v-model="formData.industry" placeholder="请输入所属行业" />
        </el-form-item> -->
        <!-- <el-form-item label="单位性质" prop="company_type">
          <el-input v-model="formData.company_type" placeholder="请输入单位性质" />
        </el-form-item>
        <el-form-item label="所属部门" prop="department">
          <el-input v-model="formData.department" placeholder="请输入所属部门" />
        </el-form-item> -->
        <el-form-item label="职务" prop="job">
          <el-input v-model="formData.job" placeholder="请输入职务" />
        </el-form-item>
        <!-- <el-form-item label="年薪（万元）" prop="salary">
          <el-input v-model="formData.salary" placeholder="请输入年薪（万元）" />
        </el-form-item> -->
        <el-form-item label="工作简介" prop="introduction">
          <el-input v-model="formData.introduction" placeholder="请输入工作简介" type="textarea" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="isAdd" type="primary" @click="submitAdd(FormRef)">确 定</el-button>
        <el-button v-else type="primary" @click="submitEdit(FormRef)">立即修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
const emit = defineEmits(['handleClose', 'submitAdd', 'submitEdit'])

const isAdd = ref(false)

const props = defineProps({
  visible: {
    required: true,
    type: Boolean,
    default: () => false
  },
  title: {
    type: String,
    default: () => '请输入标题'
  },
  data: {
    type: Object,
    default: () => {}
  }
})

const dialogVisible = computed(() => {
  return props.visible
})
const title = computed(() => {
  return props.title
})

const handleClose = () => {
  emit('update:visible', false)
  formData.value = {}
  resetForm(FormRef.value)
}

const checked = ref(false)
watch(checked, (val) => {
  if (val) {
    formData.value.end_time = '至今'
  } else {
    formData.value.end_time = ''
    resetForm(FormRef.value)
  }
})

onMounted(() => {
  if (JSON.stringify(props.data) !== '{}') {
    formData.value = { ...props.data }
    if (props.data.end_time === '至今') {
      checked.value = true
    }
  } else {
    isAdd.value = true
  }
})

const formData = ref({
  start_time: '',
  end_time: '',
  company: '',
  industry: '',
  company_type: '',
  department: '',
  job: '',
  salary: ''
})

/* 起止时间校验 */
var validateDateTime = (rule, value, callback) => {
  if (formData.value.start_time === '') {
    callback(new Error('请选择开始时间'))
  } else if (formData.value.end_time === '') {
    callback(new Error('请选择结束时间'))
  } else {
    callback()
  }
}

const rules = ref({
  dateTime: {
    required: true,
    validator: validateDateTime
  },
  company: {
    required: true,
    message: '请输入单位名称',
    trigger: 'blur'
  },
  industry: {
    required: true,
    message: '请输入所属行业',
    trigger: 'blur'
  },
  company_type: {
    required: true,
    message: '请输入单位性质',
    trigger: 'blur'
  },
  department: {
    required: true,
    message: '请输入所属部门',
    trigger: 'blur'
  },
  salary: {
    required: true,
    message: '请输入年薪（万元）',
    trigger: 'blur'
  }
})

const FormRef = ref()

function resetForm(FromEl) {
  FromEl.resetFields()
}

async function submitAdd(FormRef) {
  await FormRef.validate((valid, fields) => {
    if (valid) {
      const currData = formData.value
      emit('add', currData)
      handleClose()
    } else {
      console.log('error submit!', fields)
    }
  })
}

async function submitEdit(FormRef) {
  await FormRef.validate((valid, fields) => {
    if (valid) {
      const currDatas = JSON.parse(JSON.stringify(formData.value))
      emit('edit', currDatas)
      handleClose()
    } else {
      console.log('error submit!', fields)
    }
  })
}

</script>

<style lang="scss" scoped>
  :deep(.el-dialog__header) {
    border-bottom: 1px solid rgba(0,0,0,0.0900);
  }
  :deep(.el-dialog__footer) {
    border-top: 1px solid rgba(0,0,0,0.0900);
  }
  :deep(.el-dialog__body)  {
    padding-top: 16px;
  }
  :deep(.el-form--label-top .el-form-item__label)  {
    padding: 0;
  }
  :deep(.el-form-item) {
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
  :deep(.el-form-item .el-select) {
    width: 100%;
  }
</style>
